import {ChangeDetectionStrategy, Component} from "@angular/core";

@Component({
    selector: 'kort-samling-overskrift',
    template: '<ng-content/>',
    styleUrl: 'kort-samling-overskrift.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class KortSamlingOverskriftKomponent {

}
